module.exports = __webpack_public_path__ + "static/senograph@2x.381363bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/devices/senograph@2x.jpg
// module id = 51
// module chunks = 33781710060979 89056747556744 118332546261619